var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestframework(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.6,
    height: 112.5,
    viewBox: "0 0 183.6 112.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,27.3c6.9,0,13.7-.3,20.3.1a32.2,32.2,0,0,1,10.6,2.5c6.4,3,9.3,9.9,8.1,17.6-.8,5.9-4.1,10-9.3,12.6l-2.1,1c1.3,2.1,2.4,4.2,3.6,6.2,2.5,3.9,5,7.6,7.4,11.4a2.6,2.6,0,0,0,2.8,1.5c3.9-.1,7.8,0,11.8,0V27.4H86.8v8H63V52H99.2a18.1,18.1,0,0,1-2.4-10.8c.7-7.8,6-13.4,14.3-14.4,3.8-.4,7.7,0,11.6.1,1.2,0,2.4.3,3.6.3h57.3v8.2H166.3V88.3h-9.5V35.4h-5.7c-5.6,0-11.2.1-16.9,0-2,0-3.9-.2-4,2.2-4.3-.9-8.4-2-12.7-2.7a13.7,13.7,0,0,0-4.5.1c-3.1.5-5.5,2.1-6.4,5.2s-.3,6.3,2.4,8.3a63,63,0,0,0,8,4.5c3.4,1.8,7.1,3.2,10.3,5.3,6,4,7.6,10.1,6.4,16.9S128.1,85.8,122,87.5a38.2,38.2,0,0,1-24.3-1.1A2.2,2.2,0,0,1,96,84c.1-2.4.1-4.8.1-7.3,3.1,1,6,2.3,8.9,2.7a62,62,0,0,0,12.2.7,7.4,7.4,0,0,0,7.1-6c.8-3.7-.5-6.8-4-9s-9.4-5-15.3-4.8c-13.2.3-26.4.1-39.6.1H63V79.7H86.8v8.7H84.5c-10,0-20.1.2-30.2,0-4.4-.1-8.4.4-12,2.9q-2.8,1.8-4.8-.6a88.7,88.7,0,0,1-7.2-9C26.7,76.3,23.5,70.6,20,65.1a3.5,3.5,0,0,0-2.5-1.4c-2.6-.2-5.2-.1-8-.1V88.3H0ZM25.7,60.9l5.7-3.3c9-5.4,7.9-19.4,2.5-24.2a8.3,8.3,0,0,0-2.7-1.9c-2.6-1-5.3-2.4-8-2.5-7.2-.5-14.4-.4-21.7-.5l-.3.2V87.1h7V62.5c3.5,0,6.7-.1,10,.1A3.5,3.5,0,0,1,20.7,64c2.9,4.4,5.4,8.9,8.3,13.2s5.5,8,8.4,11.9c1.3,1.7,2.9,2.2,4.9.8s7.3-2.8,11.4-2.8c9.9.3,19.7.1,29.6.1h2.2V80.9H61.8V59.3h47.9a4.2,4.2,0,0,1,1.9.3c3.3,1.6,6.8,3.1,9.9,5s4.7,5.5,4,9.5a8,8,0,0,1-6.5,6.9,22.6,22.6,0,0,1-8.2.6c-4.5-.5-8.9-1.7-13.6-2.7,0,1.1.1,2.4,0,3.6s.5,2.9,2.4,3.5c6.9,1.9,13.9,2.5,20.9.8s11.4-6.4,12.3-13.4-2-12-8.6-15.4c-2.8-1.5-5.7-2.7-8.5-4.1s-5.6-2.7-7.8-4.7a8.7,8.7,0,0,1,3.6-14.9,13.7,13.7,0,0,1,5.7-.5c4,.6,8.1,1.5,12.3,2.3.3-1.8,1.8-1.8,3.6-1.8h24.8V87.1H165v-53h17.4V28.4H127.6c-2.1,0-4.2-.4-6.3-.5s-7-.3-10.5.2C101.2,29.5,96,37.6,98.5,47c.5,2.2,1.8,4.2,2.7,6.3H61.7V34.2H85.5V28.6H54.4V81.4H39.8a1.7,1.7,0,0,1-1.3-.9Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,112h-2a2.5,2.5,0,0,1-.2-.7V105c-.1-1.3-.5-2.5-2.1-2.5a2.3,2.3,0,0,0-2.7,2.3c-.1,2.3,0,4.7,0,7.1H109v-6.8c0-1.3-.3-2.5-1.9-2.6a2.3,2.3,0,0,0-2.7,2.2c-.2,2.4-.2,4.8-.3,7.3H102V100.6l2.5,1.1c2.5-1.6,4.1-1.6,6.6.4a9.1,9.1,0,0,1,1.6-1.1c3-1.5,5.7.1,5.8,3.4S118.5,109.4,118.5,112Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,14.9l.6-4a3.7,3.7,0,0,1-.9-4.6c.7-1.8,2.4-2.1,4.2-2.1l6.1.3L53.8,6.2c.5,4.1-.2,4.9-4.7,5.6-.5.1-.9.7-1.3,1.1s.9.7,1.4.7,2.1.1,3.2.2,2.5.8,2.7,2.4-.2,3.2-1.8,3.6a26,26,0,0,1-6.8.5,3.2,3.2,0,0,1-2-2.2c0-1.1.8-2.3,1.3-3.4Zm3,4.7.3-.4h.9c1.3-.3,3-.4,2.9-2.1s-1.8-1.3-2.9-1.4h-.9c-1.3,0-2.8.2-2.7,1.8S48.1,18.9,48.9,19.6ZM52.1,8.4v-1a7.9,7.9,0,0,0-2.5-1.7c-1.5-.2-2.1.9-2.1,2.3s.7,2.5,2,2.2S51.3,9.1,52.1,8.4Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,111.9c-2,.6-2.8,0-3.3-1.9s-1.6-6-2.4-9c1.6-.6,2.4-.2,2.7,1.5s1.1,4.1,1.8,6.8c.8-2.6,1.3-4.6,1.9-6.6s.3-2,1.8-2,1.6,1.2,1.9,2.1,1.1,4,1.9,6.6c.8-3.2,1.5-5.9,2.2-8.5h2.1v.6c-.8,2.8-1.6,5.6-2.3,8.4s-1.1,2.7-3.3,2c-.7-2.7-1.6-5.6-2.5-8.9Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,0h2.2V16L8,14.7a4.3,4.3,0,0,1-5.1.7c-2-1-2.3-2.9-2.4-5,0-4.5,1.9-6.7,5.4-6.1l2.5,1Zm.1,10q0-4.1-3-3.9c-1.7.1-2.7,1.5-2.7,4S3.8,14,5.7,14,8.5,12.8,8.5,10Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6,105.7l4.6,6.2c-4.1.9-4-3.3-6.4-4.5-2.2.8-.7,3-1.5,4.6h-1.9V96.4h2.1v9.2c2.7-1.2,3.3-5.4,7.4-4.7Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,16.1l-2.3-1.3a20,20,0,0,1-3.7,1A2.9,2.9,0,0,1,19.6,13a3.1,3.1,0,0,1,2.6-3.7,32.1,32.1,0,0,1,4.3-.7c.3-2.3-.7-3-3.3-2.4-.9.2-2,.9-2.2-1a6.2,6.2,0,0,1,5.9-.6A4.5,4.5,0,0,1,29,7.8,74.2,74.2,0,0,1,29.1,16.1Zm-2.5-5.8c-3.5.1-4.9.7-4.4,2.3A2.5,2.5,0,0,0,24.3,14C26.1,14.1,26.8,12.8,26.6,10.3Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4,104.9c-.3-2.4-1.1-3-3.6-2.3s-2,.7-2.2-1.5a52.1,52.1,0,0,1,5.5-.3c1.8.2,2.6,1.5,2.6,3.3s.1,5.2.1,8.4l-2.2-1.3a20.4,20.4,0,0,1-3.9,1,2.9,2.9,0,0,1-3.4-2.7,3.1,3.1,0,0,1,2.4-3.8C93.2,105.3,94.7,105.2,96.4,104.9Zm-.2,1.9c-3.1-.2-4.5.4-4.5,2s.9,1.7,2.1,1.7S96.6,109.1,96.2,106.8Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3,15.7V4.2l2.3,1a20,20,0,0,1,3.5-.9c2.5-.2,3.9,1,4,3.5s0,5.1,0,7.8H39.8V9c0-1.4-.2-2.7-2-2.9a2.5,2.5,0,0,0-3.1,2.6c-.2,2.2,0,4.5,0,6.9Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,4.2c3.3,0,5.3,2.2,5.3,5.8s-2,5.9-5.3,5.9-5.2-2.1-5.2-5.9S58.8,4.2,62.3,4.2ZM65.2,10c0-2.7-1.1-4-3.1-3.9s-2.8,1.5-2.8,4.1,1.1,3.8,3,3.8S65.2,12.6,65.2,10Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,106.1c.1-3.6,2-5.5,5.4-5.5s5.2,2.3,5.1,6-2,5.7-5.4,5.7S150.7,110,150.8,106.1Zm8.1.3c0-2.6-1-4-3-3.9s-2.8,1.4-2.8,4.1,1,3.8,2.9,3.8S158.9,109,158.9,106.4Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,106.9h-7.3c.3,3.5,1.8,4.2,7,3.5-.4.5-.8,1.4-1.3,1.6-2.4.5-4.9.7-6.8-1.3s-1.7-4.5-1-6.8,3.3-3.8,6.2-3.1S131.5,103.3,131.2,106.9Zm-7.3-1.8H129c-.1-1.5-.6-2.6-2.2-2.7S124.1,103.2,123.9,105.1Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,112H73.5v-9.2l-1.5-.4c.6-1.6,1.2-3,1.8-4.4s2.7-2.3,6.3-1.3c-1,.6-1.5,1.2-2,1.3-2.1.2-2.2.3-2,2.7h2.2c.3,1.6.3,1.6-2.4,1.9Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3,4.5h2.2c0,4.6.1,9.2-.1,13.8-.1,1.9-2.6,3.1-4.4,2.3s-.5-.9-1-1.8c3.2.5,3.4-1.2,3.3-3.3S14.3,8.3,14.3,4.5Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,112H81V100.5l2.3,1.5,4.1-1.6.6,1c-.6.4-1.1,1.1-1.7,1.2s-3.1,1.6-3.1,3.6S83.2,110,83.2,112Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,101.4a6.4,6.4,0,0,1-1.7,1.3,3.3,3.3,0,0,0-3.1,3.6v5.6h-2.2V100.4l2.3,1.6,4-1.6Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,1.3c-.7.6-1.2,1.2-1.6,1.2s-.9-.6-1.4-.9S15,.4,15.5.2,16.4.8,17.2,1.3Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,57V33.8c5.1.5,10.2.5,15.1,1.6s7.6,5.4,7,11.7-4.2,8.7-9.9,9.3C16.5,56.8,12.5,56.8,8.3,57Zm1.2-1c4.6-.4,9-.5,13.3-1.4s6.5-4.5,6.4-9.6-2-7.7-6.5-8.6S14,35.5,9.5,35.1Z",
    style: {
      fill: "#19405e"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestframework);
export default __webpack_public_path__ + "static/media/restframework.cf1f87db8d3980a840ce09ae65fee329.svg";
export { ForwardRef as ReactComponent };